<template>
  <div id="cup_leagueTable" v-show="currThemeObj">
    <div class="abs_topArea">积分榜</div>
    <template v-if="showSelectCidArr.includes(currCid)">
      <div class="select_area">
        <marathon_select_opt
          :currThemeObj="currThemeObj"
          :data="selectOptData"
          @changeSelectEvent="changeSelect"
        ></marathon_select_opt>
      </div>
    </template>

    <div class="teamList_area" ref="teamListArea" v-if="!isNotDataFlag">
      <!-- <div class="themeOperation_area">
        <span class="themeType_changeArea">
          <span
            class="themeType_item"
            v-for="item in themeTypeArr"
            :key="item.id"
            :class="item.act ? 'act' : ''"
            v-text="item.name"
            @click="changeThemeType(item)"
          ></span>
        </span>
      </div> -->
      <!-- <span class="groupTitle" v-text="groupTitle"></span> -->
      <div
        class="cup_table_item"
        v-for="(table, index) in cup_teamListGroup"
        :key="index"
      >
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :parentWidthPx="cup_table_parentWidthPx"
          :isScrollFlag="table.isScrollFlag"
          :variableColWidthVw="table.variableColWidthVw"
          :tableCellDefaultWidthVw="table.tableCellDefaultWidthVw"
          :defaultWidthVwNum="table.defaultWidthVwNum"
          :tableColumnData="table.tableColumnData"
          :tableData="table.tableData"
          :jumpRouterPathNames="jumpRouterPathNames"
          :unClickDetailMode="unClickDetailMode"
          v-show="cup_table_parentWidthPx && cup_teamListGroup.length >= 0"
        ></nodeTree_table>
        <template v-if="curThemeItem">
          <span
            class="cup_table_publishBtn"
            @click="clickPublicTheme(curThemeItem, table)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>
        </template>
      </div>
    </div>
    <cup_notData v-if="isNotDataFlag" :className="'relativePt60'"></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import { https_package_findAnalysisItem } from '@api/platfrom_base_api'
import {
  https_cup_leagueTableStage,
  https_cup_leagueTable,
} from '@api/platfrom_football_api'
import { https_basketballCup_leagueTable } from '@api/platfrom_basketball_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
export default {
  name: 'cup_leagueTable',
  mixins: [cup_base_data_mixin],
  components: {
    nodeTree_table,
    cup_notData,
    marathon_select_opt,
  },
  data() {
    return {
      showSelectCidArr: ['112'],
      basketballCupCidArr: ['202', '203'],
      groupTitle: '',
      cup_table_parentWidthPx: 0,
      cup_teamListGroup: null,
      dataItemId: null,
      isNotDataFlag: false,
      themeTemplateTypeArr: [21, 4],
      themeTemplateType: 4,
      curThemeItem: null,
      // themeTypeArr: [
      //   {
      //     name: '积分榜',
      //     id: 'web',
      //     act: true,
      //   },
      //   {
      //     name: '实时积分榜',
      //     id: 'broadcast',
      //     act: false,
      //   },
      // ],
      currStageEvent: null,
      stageArr: [],
      selectOptData_origin: {
        configArr: [
          {
            type: 'stage',
            title: '阶段',
            origin_keyVal: ['stageId', 'stageName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'stageArr', //this下面的存储该数据list字段名
            selectIndex: 0,
          },
        ],
        selectOpt_list: [],
      },
      selectOptData: null,
      jumpRouterPathNames: null,
    }
  },
  created() {
    console.debug('this.currThemeObj:', this.currThemeObj)
    const sportTypeArr = ['basketball', 'football']
    if (this.currThemeObj) {
      const index = sportTypeArr.indexOf(this.currThemeObj.sportType)
      this.themeTemplateType = this.themeTemplateTypeArr[index]
      const jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
      }
      this.jumpRouterPathNames = jumpRouterPathNames
    }
    if (this.currGroup) {
      this.init()
    }
    // this.themeTypeArr.forEach((item) => {
    //   if (item.act) {
    //     this.currThemeType = item
    //   }
    // })
  },
  mounted() {
    // console.debug(this.$refs)
    this.cup_table_parentWidthPx = this.$refs.teamListArea.offsetWidth
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (this.showSelectCidArr.includes(this.currCid)) {
        this.selectOptData = JSON.parse(
          JSON.stringify(this.selectOptData_origin)
        )
        await this.getParstage()
        this.computedSelectOpt(this.selectOptData.configArr)
      }
      if (this.basketballCupCidArr.includes(this.currCid)) {
        // 篮球杯赛
        await this.getBasketballCupLeagueTable(this.currStageEvent)
      } else {
        // 足球杯赛
        await this.getLeagueTable(this.currStageEvent)
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      await this.findAnalysisItem(this.themeTemplateType)
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'stage') {
            this.currStageEvent = valPathArr[1]
            window.mixtmtBase_eventBus.$emit('loadingEvent', true)
            await this.getLeagueTable(this.currStageEvent)
          }

          window.mixtmtBase_eventBus.$emit('loadingEvent', false)
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    onResizeEvent() {
      if (this.$refs.teamListArea) {
        this.cup_table_parentWidthPx = this.$refs.teamListArea.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    // changeThemeType(btnItem) {
    //   this.themeTypeArr.forEach((item, index) => {
    //     if (item.id === btnItem.id) {
    //       item.act = true
    //       this.currThemeType = item
    //       this.curThemeItem = this.themeItemArr[index]
    //     } else {
    //       item.act = false
    //     }
    //   })
    // },
    clickPublicTheme(themeItem, table) {
      if (!themeItem) return
      // 分享主题
      let keyArrActJson = []
      let newThemeItem = JSON.parse(JSON.stringify(themeItem))
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      newThemeItem.actJson[keyArrActJson[0]] = table[keyArrActJson[0]]
      console.debug('newThemeItem:', newThemeItem, table)
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      newThemeItem.analysisItemName = `${table.seriesName}${newThemeItem.analysisItemName || ''}`
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
      })
    },
    async getParstage() {
      await https_cup_leagueTableStage(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const stageArr = res.data && res.data.length > 0 ? res.data : []
            // this.stageArr = [].concat(
            //   [
            //     {
            //       stageId: '-1',
            //       stageName: '全部',
            //     },
            //   ],
            //   stageArr
            // )
            this.stageArr = stageArr
            this.currStageEvent =
              this.stageArr[this.selectOptData.configArr[0].selectIndex].stageId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getLeagueTable(stageCode) {
      console.debug('getLeagueTable:', stageCode)
      let params = {
        sid: this.currSid,
        cid: this.currCid,
      }
      if (stageCode) {
        params.stageCode = stageCode
      }
      await https_cup_leagueTable(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.cup_teamListGroup = res.data
              ? res.data.map((val) => {
                  // if (!this.dataItemId) {
                  //   this.dataItemId = val.analysisItemId
                  // }
                  // if (!this.groupTitle) {
                  //   this.groupTitle = val.title
                  // }
                  console.debug('val:', val)
                  let singleTable = {
                    isScrollFlag: false,
                    variableColWidthVw: 25.42, // 可变化的宽度
                    tableCellDefaultWidthVw: 5.55, // 默认宽度 ,
                    defaultWidthVwNum: 8,
                    tableColumnData: [
                      {
                        prop: 'rankNum-teamLogo-teamName',
                        label: val.seriesName,
                        widthVw: 25.42,
                        className: 'columnNumLogoNameClass',
                        fixed: 'left',
                      },
                      {
                        prop: 'matchesPlayed',
                        label: '场次',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'matchesWon',
                        label: '胜',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'matchesDrawn',
                        label: '平',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'matchesLost',
                        label: '负',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'goalsFor',
                        label: '进球',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'goalsAgainst',
                        label: '失球',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'goalsDifference',
                        label: '净胜球',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'points',
                        label: '积分',
                        widthVw: 5.55,
                      },
                      {
                        prop: '',
                        label: '',
                        widthVw: 4.16,
                      },
                    ],
                    tableData: val.dataList.map(val => ({
                      ...val,
                      teamName: val.teamName + (val.isQualified ? '(晋级)' : '')
                    })),
                    seriesCode: val.seriesCode,
                    seriesName: val.seriesName,
                    // analysisItemId: val.analysisItemId,
                    // json: val.json,
                    // seasonOrMatch: val.seasonOrMatch,
                    // title: val.title,
                  }
                  return singleTable
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async findAnalysisItem(templateType) {
      // 获取所有主题信息
      const params = {
        templateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.themeItemArr = res.data.map((item) => {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.actJson = JSON.parse(newItem.json)
              newItem.renderData = null
              if (newItem.analysisItemStyles) {
                // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
                let initAct =
                  newItem.analysisItemStyles.length === 1 ? true : false
                newItem.analysisItemStyles.forEach((styleItem, styleIndex) => {
                  if (initAct && styleIndex === 0) {
                    styleItem.act = true
                  } else {
                    styleItem.act = false
                  }
                })
              }
              newItem.title2RightName =
                newItem.analysisItemStyles && newItem.analysisItemStyles.length
                  ? `${newItem.analysisItemStyles.length}种风格`
                  : ''
              return newItem
            })
            if (this.themeItemArr.length > 0) {
              this.curThemeItem = this.themeItemArr[0]
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBasketballCupLeagueTable(stageCode) {
      console.debug('getLeagueTable:', stageCode)
      let params = {
        sid: this.currSid,
        cid: this.currCid,
      }
      if (stageCode) {
        params.stageCode = stageCode
      }
      await https_basketballCup_leagueTable(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }

            this.cup_teamListGroup = res.data
              ? res.data.map((val) => {
                  console.debug('val:', val)
                  let singleTable = {
                    isScrollFlag: false,
                    variableColWidthVw: 25.42, // 可变化的宽度
                    tableCellDefaultWidthVw: 5.55, // 默认宽度 ,
                    defaultWidthVwNum: 7,
                    tableColumnData: [
                      {
                        prop: 'rankNum-teamLogo-teamName',
                        label: val.seriesName,
                        widthVw: 25.42,
                        className: 'columnNumLogoNameClass',
                        fixed: 'left',
                      },
                      {
                        prop: 'games',
                        label: '场次',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'wins',
                        label: '胜',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'losses',
                        label: '负',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'avgPointsFor',
                        label: '场均得分',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'avgPointsAgainst',
                        label: '场均失分',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'avgPointsDifference',
                        label: '场均净胜分',
                        widthVw: 5.55,
                      },
                      {
                        prop: 'points',
                        label: '积分',
                        widthVw: 5.55,
                      },
                      {
                        prop: '',
                        label: '',
                        widthVw: 4.16,
                      },
                      // {
                      //   prop: 'war',
                      //   label: '邮编12',
                      //   widthVw: 10,
                      //   fixed: 'right',
                      // },
                    ],
                    tableData: val.dataList.map(val => ({
                      ...val,
                      teamName: val.teamName + (val.isQualified ? '(晋级)' : '')
                    })),
                    seriesCode: val.seriesCode,
                    seriesName: val.seriesName,
                    // analysisItemId: val.analysisItemId,
                    // json: val.json,
                    // seasonOrMatch: val.seasonOrMatch,
                    // title: val.title,
                  }
                  return singleTable
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_leagueTable {
  padding-top: 8.68vw;
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 2vw 0 0 9.722vw;
    width: 100%;
    height: 8.68vw;
    font-size: 3vw;
    line-height: 6.68vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }

  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
  }

  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 2.778vw;
    .themeOperation_area {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 2.5vw;
      margin-bottom: 1.388vw;
      .themeType_changeArea {
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
        border-radius: 1.25vw;
        .themeType_item {
          width: 8.62vw;
          line-height: calc(2.5vw - 2px);
          text-align: center;
          color: var(--mixtmt_btn_tabMeun_actColor);
          font-size: 0.972vw;
          &.act {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
        }
      }
      .themeBtn_area {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        span {
          display: inline-block;
          margin-left: 0.972vw;
          line-height: calc(2.5vw - 2px);
          font-size: 1.11vw;
          padding: 0 0.972vw;
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
          border-radius: 2px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    .groupTitle {
      display: block;
      padding-bottom: 0.972vw;
      font-size: 1.388vw;
      line-height: 1.944vw;
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
    .cup_table_item {
      position: relative;
      .cup_table_publishBtn {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: 4.16vw;
        height: 3.332vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_table_publicBtnColor);
        }
      }
    }
  }
}
.mixtmt_pc #cup_leagueTable,
.mixtmt_ipad #cup_leagueTable {
  padding: 8.68vw 0 0;
}
.mixtmt_pc #cup_leagueTable {
  .teamList_area {
    .themeOperation_area {
      .themeType_changeArea {
        .themeType_item {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
        }
      }
      .themeBtn_area {
        span {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_btn_tabMeun_actColor);
            color: var(--mixtmt_whiteColor);
          }
        }
      }
    }
    .cup_table_item {
      .cup_table_publishBtn {
        cursor: pointer;
        &:hover {
          svg.publishBtn_icon {
            fill: var(--mixtmt_subColor1_1);
          }
        }
      }
    }
  }
}
</style>
